import { Link } from "react-router-dom";
import { House, ArrowLeft } from "@phosphor-icons/react";
import { Helmet } from "react-helmet-async";

const NotFoundPage = () => (
  <section className="min-h-[70vh] flex items-center bg-[#fff6ec]" data-testid="not-found-page">
    <Helmet>
      <title>Page not found · Infini10 Technologies</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <div className="max-w-3xl mx-auto px-6 text-center">
      <p className="text-xs uppercase tracking-[0.22em] font-bold text-[#1f2a44]">404 · Lost in transit</p>
      <h1 className="mt-5 font-display text-5xl sm:text-6xl font-bold tracking-tight text-[#1f2a44]">
        That page isn&apos;t in our records.
      </h1>
      <p className="mt-6 text-lg text-slate-600">
        Sorry — the page you were looking for has either been moved or never existed. Let&apos;s get you somewhere useful.
      </p>
      <div className="mt-10 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          data-testid="not-found-home"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#1f2a44] text-[#fe4c1c] text-sm font-semibold hover:bg-[#152038]"
        >
          <House size={18} weight="bold" /> Back home
        </Link>
        <Link
          to="/services"
          data-testid="not-found-services"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[#1f2a44] text-[#1f2a44] text-sm font-semibold hover:bg-[#1f2a44] hover:text-white"
        >
          <ArrowLeft size={18} weight="bold" /> Explore services
        </Link>
      </div>
    </div>
  </section>
);

export default NotFoundPage;
